export const getIsMobile = () => {
  const ua = navigator.userAgent
  return /iPhone|Android.+Mobile/.test(ua)
}
